import { Modal, Box } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import React, { useEffect, useState } from 'react';
import PlainButton, { UnileverButton } from './ButtonComponents';
import DropDownComponent, {
  RadioButtonGroup,
  SearchableDropDownComponent,
  TextArea,
  TextFieldComponent
} from './inputField';
import { ReactComponent as EditPrompt } from '../assets/icon/EditPrompt.svg';
import { useNavigate } from 'react-router-dom';
import { usePromptPlaygroundContext } from '../context/PromptPlayGroundContext';
import { usePromptContext } from '../context/PromptContextType';

export default function SavePromptPopUp({
  open = false,
  handleClose,
  header = '',
  description = '',
  isNew = '',
  inputData = { model: '', systemPrompt: '', variable: [] },
  allMessages = [],
  selectedVersion = 1,
  dataToShow = {},
  children
}: {
  open?: boolean;
  handleClose?: () => void;
  header?: string;
  description?: string;
  isNew?: string;
  children?: React.ReactNode;
  inputData?: { model: string; systemPrompt: string; variable: [] };
  allMessages?: [];
  dataToShow?: {};
  selectedVersion?: number;
}) {
  const { savePromptPlaygroundFunction, savePromptStatus } = usePromptPlaygroundContext();
  // const navigate = useNavigate();
  const [radiobtn, setRadioButton] = useState([
    {
      id: 0,
      text: 'Save to this Version',
      checked: false
    },
    {
      id: 1,
      text: 'Save as a new Version',
      checked: false
    }
  ]);
  const [radioButtonSelection, setRadioButtonSelection] = useState('');
  const [versionDetails, setVersionDetails] = useState({
    availableVersions: [],
    totalVersions: 0
  });

  useEffect(() => {
    if (open && Array.isArray(dataToShow?.promptsData)) {
      const prompts = dataToShow.promptsData;
      const lastestVersion = prompts.at(-1)?.prompt?.promptVersion || '0';
      const available = prompts.map((item) => item?.prompt?.promptVersion);

      setVersionDetails({
        availableVersions: available,
        totalVersions: parseInt(lastestVersion, 10) || 0
      });
    } else {
      setVersionDetails({ availableVersions: [], totalVersions: 0 });
    }

    // return () => {
    //   setRadioButtonSelection('');
    // };
  }, [open, dataToShow?.promptsData]);

  useEffect(() => {
    if (open) {
      businessCategoryFunction();
    }

    if (!open) {
      setNewPromptData({ description: '', businessCategories: '' });
      setRadioButtonSelection('');
    }
  }, [open]);

  const [newPromptData, setNewPromptData] = useState({
    promptName: '',
    description: '',
    businessCategories: '',
    viewType: 0
  });

  const handleRadioButton = (a) => {
    const updated = radiobtn.map((item, index) => ({
      ...item,
      checked: index === a
    }));
    setRadioButton(updated);
    setRadioButtonSelection(a);
  };

  const isOwner = dataToShow?.meta?.is_owner || false;
  const configData = dataToShow?.configData;
  const selectedPromptVersion = dataToShow?.promptsData?.filter(
    (item) => item?.prompt?.promptVersion == selectedVersion
  )?.[0];

  const dataNew = {
    businessGroup:
      newPromptData?.businessCategories || selectedPromptVersion?.prompt?.businessGroup,
    promptName: newPromptData?.promptName,
    promptVersion: selectedPromptVersion?.promptVersion || '1',
    llmTestedWith: inputData?.model || dataToShow?.configData?.model,
    promptDescription:
      newPromptData?.description || selectedPromptVersion?.prompt?.promptDescription,
    is_prompt_type_private: selectedPromptVersion?.prompt?.is_prompt_type_private || true,
    is_prompt_type_single: !!selectedPromptVersion?.roles?.length,
    systemPrompt: inputData?.systemPrompt || selectedPromptVersion?.prompt?.systemPrompt,
    variables: inputData?.variable?.length ? inputData?.variable : selectedPromptVersion?.variables
  };

  const payloadNew = {
    ...dataNew,
    conversation: {
      user_prompt: 'Answer the question briefly.',
      roles: allMessages
    }
  };

  const payloadAll = {
    ...dataNew,
    source: 'all',
    save_mode: 'new_prompt',
    // promptName: newPromptData?.promptName || selectedPromptVersion?.prompt?.promptName,
    // promptDescription:
    //   newPromptData?.description || selectedPromptVersion?.prompt?.promptDescription,
    // businessGroup: newPromptData?.businessCategories,
    is_prompt_type_private: newPromptData?.viewType == 1,
    conversation: {
      roles: allMessages
    }
  };

  const dataEdit = {
    source_prompt_id: dataToShow?.prompt_id,
    systemPrompt: inputData?.systemPrompt || selectedPromptVersion?.prompt?.systemPrompt,
    variables: inputData?.variable?.length ? inputData?.variable : selectedPromptVersion?.variables,
    // llmTestedWith mentioned for saving Prompt in ComparePrompt
    llmTestedWith: dataToShow?.configData?.model
  };
  const payloadMy = {
    ...dataEdit,
    source: 'my',
    save_mode: radioButtonSelection ? 'save_to_new_version' : 'save_to_version',
    base_version_id: selectedPromptVersion?.version_id,
    conversation: {
      roles: allMessages
    },
    promptDescription: selectedPromptVersion?.prompt?.promptDescription
  };

  var payload = {};
  const [nameError, setNameError] = useState(false);
  const { promptNameCheckFunction, businessCategories, businessCategoryFunction } =
    usePromptContext();

  //   useEffect(()=>{
  // if (businessCategories?.data) {
  //  console.log(businessCategories, 'vvvbusinessCategories');
  // }

  // },[businessCategories])

  // console.log(businessCategories, 'vvvbusinessCategories');

  const handleSavePrompt = async () => {
    const tempName = newPromptData?.promptName || '';
    if (!isOwner && !!tempName) {
      if (tempName) {
        const nameExist = await promptNameCheckFunction(tempName);
        if (nameExist?.exists) {
          setNameError(true);
          return;
        } else {
          setNameError(false);
        }
      }
    }
    if (isOwner) {
      payload = payloadMy;
    } else {
      if (isNew) {
        payload = payloadAll;
      } else {
        payload = payloadNew;
      }
    }
    savePromptPlaygroundFunction(payload);
  };

  useEffect(() => {
    if (savePromptStatus?.loading) {
      return;
    }

    if (savePromptStatus?.error) {
      alert(savePromptStatus?.error);
      console.log(error);
    } else {
      handleClose();
    }
  }, [savePromptStatus]);

  const buttonDisableForNewSavePrompt = !(
    newPromptData?.promptName &&
    newPromptData?.businessCategories &&
    newPromptData?.description &&
    newPromptData?.viewType
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <Box
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '40%',
          margin: 'auto',
          borderRadius: '8px',
          padding: 20,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          maxWidth: 600,
          height: isOwner ? 400 : 700
        }}>
        <EditPrompt />

        <div className="p-4" style={{ paddingTop: 0 }}>
          <div className="d-flex flex-column  align-items-center">
            <div
              className="h6 w600 un_standard_color text-center"
              style={{
                margin: '10px 0',
                color: 'var(--uni_std_clr)'
              }}>
              {header}
            </div>
            <p className="h6 w400 text-center" style={{ fontWeight: 400 }}>
              {description}
            </p>
          </div>{' '}
          {/* <Close style={{ cursor: 'pointer' }} onClick={handleClose} /> */}
        </div>
        <div className="w-100  p-2 d-flex flex-column justify-content-evenly">
          {!isOwner ? (
            <>
              <TextFieldComponent
                header={'Prompt Name'}
                isMandatory={true}
                value={newPromptData?.promptName}
                placeholder={'Prompt Name'}
                handleSelection={(a: string, b: string) => {
                  setNewPromptData((prev) => ({ ...prev, promptName: b }));
                }}
                error={nameError}
              />

              <TextArea
                header="Prompt Description"
                isMandatory={true}
                areaStyle={{ height: '100px' }}
                placeholder="Enter Small description of your Prompt"
                value={newPromptData?.description}
                action={(a) => setNewPromptData((prev) => ({ ...prev, description: a }))}
              />

              <SearchableDropDownComponent
                fieldName="Business Category"
                isMandatory={true}
                value={newPromptData?.businessCategories}
                options={businessCategories?.data || []}
                paramName={'businessGroup'}
                handleSelection={(a, b) => {
                  setNewPromptData((prev) => ({ ...prev, businessCategories: b }));
                }}
              />
              <DropDownComponent
                isMandatory={true}
                fieldName="View Type"
                value={newPromptData?.viewType}
                options={[
                  { title: 'Private', id: 1 },
                  { title: 'Public', id: 2 }
                ]}
                handleSelection={(a?: string, b?: string) => {
                  setNewPromptData((prev) => ({ ...prev, viewType: b }));
                }}
              />
            </>
          ) : (
            <RadioButtonGroup
              options={radiobtn}
              handleSelection={(a) => handleRadioButton(a)}
              versionDetail={{
                selected: selectedVersion,
                total: versionDetails?.totalVersions || 0
              }}
              isEditPrompt={true}
              newVersion={versionDetails?.totalVersions + 1 || 0}
            />
          )}
        </div>

        <Box
          className="d-flex justify-content-end w-100 mt-3"
          style={{ borderTop: '1px solid var(--uni_std_clr)', paddingTop: 20 }}>
          <PlainButton
            buttonAction={handleClose}
            styleClass={{
              color: 'var(--uni_std_clr)',
              borderShadow: 'rgba(0, 0, 0, 0.05)',
              marginRight: '10px'
            }}>
            Cancel
          </PlainButton>
          {savePromptStatus?.loading ? (
            <PlainButton
              buttonAction={() => {}}
              styleClass={{
                color: 'var(--uni_std_clr)',
                borderShadow: 'rgba(0, 0, 0, 0.05)',
                marginRight: '10px'
              }}>
              Loading..
            </PlainButton>
          ) : (
            <UnileverButton
              disabled={
                isOwner
                  ? [null, undefined]?.indexOf(radioButtonSelection) > -1
                  : buttonDisableForNewSavePrompt
              }
              buttonAction={handleSavePrompt}>
              {'Save Prompt'}
            </UnileverButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
